/* Maison Méliqua : automatismes du panier.
   - Bracelet Nora offert dès 100 € de bijoux (produit « Nora offert », rendu gratuit par la réduction automatique Shopify).
     Le seuil se calcule sur les bijoux avant code promo, sans la pochette cadeau ni le Nora offert.
     La cliente peut retirer le cadeau : on ne le remet pas tant que le panier reste au-dessus du seuil.
   - Pochettes cadeau cochées sur la fiche produit, ajoutées en même quantité que le bijou.
   - Mise à jour du panier sans recharger la page (repli : rechargement si le thème ne répond pas). */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 64707950281081; // Nora offert
  var GIFT_WRAP_VARIANT_ID = 64690735219065; // Pochette cadeau
  var THRESHOLD_CENTS = 10000; // 100,00 €
  var GIFT_PROPERTY = { Offert: 'Dès 100 € de bijoux' };
  var DECLINE_KEY = 'mm_nora_refuse';

  var syncing = false;
  var resyncQueued = false;
  var pendingWrapQty = 0;
  var sawGift = false;

  function routes() {
    return (
      (window.Theme && window.Theme.routes) || {
        cart_add_url: '/cart/add.js',
        cart_change_url: '/cart/change.js',
        cart_url: '/cart',
      }
    );
  }

  function jsonPost(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function getCart() {
    return nativeFetch(routes().cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function eligibleSubtotal(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id === GIFT_VARIANT_ID || item.variant_id === GIFT_WRAP_VARIANT_ID) return;
      total += item.original_line_price;
    });
    return total;
  }

  function findLine(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return cart.items[i];
    }
    return null;
  }

  function declined(cart) {
    try {
      return sessionStorage.getItem(DECLINE_KEY) === String(cart.token);
    } catch (e) {
      return false;
    }
  }

  function setDeclined(cart, on) {
    try {
      if (on) sessionStorage.setItem(DECLINE_KEY, String(cart.token));
      else sessionStorage.removeItem(DECLINE_KEY);
    } catch (e) {}
  }

  /* Rafraîchit le tiroir / la page panier et la pastille du panier, sans recharger la page. */
  function refreshCartUI(cart) {
    var bubbles = document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count');
    bubbles.forEach(function (el) {
      el.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
    });
    var comps = document.querySelectorAll('cart-items-component[data-section-id]');
    if (!comps.length) return Promise.resolve();
    return import('@theme/section-renderer')
      .then(function (mod) {
        comps.forEach(function (c) {
          mod.sectionRenderer.renderSection(c.dataset.sectionId, {
            cache: false,
            mode: c.dataset.drawer !== undefined ? 'hydration' : 'full',
          });
        });
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function sync() {
    if (syncing) {
      resyncQueued = true;
      return;
    }
    syncing = true;

    getCart()
      .then(function (cart) {
        var actions = [];
        var eligible = eligibleSubtotal(cart) >= THRESHOLD_CENTS;
        var giftLine = findLine(cart, GIFT_VARIANT_ID);

        if (!eligible) setDeclined(cart, false);

        // La cliente vient de retirer le cadeau alors qu'elle y a droit : on respecte son choix.
        if (eligible && !giftLine && sawGift) setDeclined(cart, true);

        if (eligible && !giftLine && !declined(cart)) {
          actions.push(jsonPost(routes().cart_add_url, { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: GIFT_PROPERTY }] }));
        } else if (!eligible && giftLine) {
          actions.push(jsonPost(routes().cart_change_url, { id: giftLine.key, quantity: 0 }));
        } else if (giftLine && giftLine.quantity > 1) {
          actions.push(jsonPost(routes().cart_change_url, { id: giftLine.key, quantity: 1 }));
        }

        if (pendingWrapQty > 0) {
          var qty = pendingWrapQty;
          pendingWrapQty = 0;
          actions.push(jsonPost(routes().cart_add_url, { items: [{ id: GIFT_WRAP_VARIANT_ID, quantity: qty }] }));
        }

        if (actions.length === 0) {
          sawGift = !!giftLine;
          return null;
        }

        return Promise.all(actions)
          .then(getCart)
          .then(function (fresh) {
            sawGift = !!findLine(fresh, GIFT_VARIANT_ID);
            return refreshCartUI(fresh);
          });
      })
      .catch(function (err) {
        console.warn('[mm-cart-automations]', err);
      })
      .finally(function () {
        syncing = false;
        if (resyncQueued) {
          resyncQueued = false;
          sync();
        }
      });
  }

  function collectRequestedWraps() {
    var checkboxes = document.querySelectorAll('[data-gift-wrap-checkbox]:checked');
    checkboxes.forEach(function (cb) {
      var scope = cb.closest('form') || cb.closest('product-form-component') || document;
      var qtyInput = scope.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;
      pendingWrapQty += qty;
      cb.checked = false;
    });
  }

  // Surveille les requêtes du thème qui modifient le panier (fiche produit, ajout rapide, quantités…).
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function () {
    var input = arguments[0];
    var url = input instanceof Request ? input.url : input;
    var urlString = typeof url === 'string' ? url : '';
    var isAdd = urlString.indexOf('/cart/add') !== -1;
    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(urlString);

    if (isAdd) collectRequestedWraps();

    var result = nativeFetch.apply(window, arguments);

    if (isCartMutation) {
      result
        .then(function () {
          setTimeout(sync, 250);
        })
        .catch(function () {});
    }

    return result;
  };

  document.addEventListener('click', function (event) {
    // « Ajouter une pochette cadeau » dans le panier
    var wrap = event.target.closest('[data-add-gift-wrap]');
    if (wrap) {
      event.preventDefault();
      wrap.disabled = true;
      jsonPost(routes().cart_add_url, { items: [{ id: GIFT_WRAP_VARIANT_ID, quantity: 1 }] })
        .then(getCart)
        .then(refreshCartUI)
        .catch(function (err) {
          console.warn('[mm-cart-automations]', err);
        })
        .finally(function () {
          wrap.disabled = false;
        });
      return;
    }

    // « Remettre mon bracelet offert » après l'avoir retiré
    var gift = event.target.closest('[data-mm-add-gift]');
    if (gift) {
      event.preventDefault();
      gift.disabled = true;
      getCart()
        .then(function (cart) {
          setDeclined(cart, false);
          return jsonPost(routes().cart_add_url, { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: GIFT_PROPERTY }] });
        })
        .then(getCart)
        .then(function (fresh) {
          sawGift = true;
          return refreshCartUI(fresh);
        })
        .catch(function (err) {
          console.warn('[mm-cart-automations]', err);
          gift.disabled = false;
        });
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
